export enum HouseholdType {
  COUPLE_WITHOUT_CHILDREN = 'COUPLE_WITHOUT_CHILDREN',
  FAMILY = 'FAMILY',
  FLATSHARE = 'FLATSHARE',
  SINGLE = 'SINGLE',
  SINGLE_WITH_CHILDREN = 'SINGLE_WITH_CHILDREN'
}
